import { all } from "redux-saga/effects";
import AuthSagas from "./Auth/sagas";
import EmployeesSagas from "./Employees/sagas";
import EventsSagas from "./Events/sagas";
import LookupsSagas from "./Lookups/sagas";
import RequestsSagas from "./Requests/sagas";
import ApplicantsSagas from "./applicants/sagas";
import PromotionRequestsSagas from "./PromotionRequests/sagas";
import RegistrationReqSagas from "./RegistrationReq/sagas";
import companiesListSagas from "./CompaniesList/sagas";
import profileEditRequestsSagas from "./ProfileEditRequests/sagas";
import NotificationsSagas from "./Notifications/sagas";
import DailyReportsRequestsSagas from "./TimeSheet/sagas";
import ApplicantsTimeSheetRequestsListSaga from "./ApplicantsTimeSheet/sagas";
import TrainingWorkingSlotsSaga from "./TrainingWorkingSlots/sagas";
import EvaluationsEventSagas from "./Evaluations/sagas";
import LocationsSagas from "./Locations/sagas";
import NoteSagas from "./Notes/sagas";
import filterSaga from "./Filter/sagas";
import ReasonSagas from "./Reasons/sagas";
import ReportSagas from "./Reports/sagas";
import joiningRequest from "./JoiningRequest/sagas";
import applicantTabRequestSaga from "./ApplicantsTab/sagas";
import persistEmployeeSaga from "./PersistEmployees/sagas";
import persistTimeSheetSaga from "./PersistTimeSheet/sagas";
import persistTimeSheetEventSaga from "./PersistTimeSheetEvent/sagas";
import RolesSaga from "./Role/sagas";
import persistReportSaga from "./PersistReport/sagas";
import ClientsSagas from "./clients/sagas";
import { watchCreateSurveySaga, watchSurveySaga } from "./Survey/saga";
import HeatmapSagas from "./HeatMap/sagas";
import { watchFetchRoles } from "./Roles/saga";
import ApplicantReportSagas from "./ApplicantReports/sagas";
import ApplicantTabExportSheetSaga from "./ApplicantTabExportSheet/sagas";
import companyEditRequestSagas from "./CompanyPortal/Settings/EditProfile/sagas";
import companyMyCompanySagas from "./CompanyPortal/MyCompany/sagas";
import companyEventRequestsSagas from "./CompanyPortal/EventRequests/sagas";
import companyRolesSagas from "./CompanyPortal/Roles/sagas";
import companyEmployeesSagas from "./CompanyPortal/Employees/sagas";
import companyClientsSagas from "./CompanyPortal/Clients/sagas";
import companyLogisticsIssuesSagas from "./CompanyPortal/LogisticsIssues/sagas";
import companyLoyalApplicantsSagas from "./CompanyPortal/LoyalApplicants/sagas";
import companyApplicantProfileSagas from "./CompanyPortal/ApplicantProfile/sagas";
import companyEventTimesheetSagas from "./CompanyPortal/EventTimesheet/sagas";
import companyEvaluationsSagas from "./CompanyPortal/Evaluations/sagas";
import CompanyNotificationsSagas from "./CompanyPortal/Notifications/sagas";
import ClientNotificationsSagas from "./ClientPortal/Notifications/sagas";
import adminEventRequestsSagas from "./AdminEventRequests/sagas";
import userTagsSagas from "./UserTags/sagas";
import DemoRequestsSagas from "./DemoRequests/sagas";
import payrollSagas from "./Payroll/sagas";
import adminDashboardSagas from "./AdminDashboard/sagas";
import companyDashboardSagas from "./CompanyPortal/Dashboard/sagas";
import activityLogsSagas from "./ActivityLogs/sagas";
import companyActivityLogsSagas from "./CompanyPortal/ActivityLogs/sagas";

export default function* rootSaga() {
  yield all([
    watchFetchRoles(),
    HeatmapSagas(),
    watchSurveySaga(),
    watchCreateSurveySaga(),
    AuthSagas(),
    ClientsSagas(),
    EmployeesSagas(),
    LookupsSagas(),
    EventsSagas(),
    RequestsSagas(),
    ApplicantsSagas(),
    PromotionRequestsSagas(),
    RegistrationReqSagas(),
    companiesListSagas(),
    profileEditRequestsSagas(),
    EvaluationsEventSagas(),
    NotificationsSagas(),
    DailyReportsRequestsSagas(),
    ApplicantsTimeSheetRequestsListSaga(),
    TrainingWorkingSlotsSaga(),
    LocationsSagas(),
    NoteSagas(),
    filterSaga(),
    ReasonSagas(),
    ReportSagas(),
    joiningRequest(),
    applicantTabRequestSaga(),
    persistEmployeeSaga(),
    persistTimeSheetSaga(),
    persistTimeSheetEventSaga(),
    RolesSaga(),
    persistReportSaga(),
    ApplicantReportSagas(),
    ApplicantTabExportSheetSaga(),
    companyEditRequestSagas(),
    companyMyCompanySagas(),
    companyEventRequestsSagas(),
    companyRolesSagas(),
    companyEmployeesSagas(),
    companyClientsSagas(),
    companyLogisticsIssuesSagas(),
    companyLoyalApplicantsSagas(),
    companyApplicantProfileSagas(),
    companyEventTimesheetSagas(),
    companyEvaluationsSagas(),
    CompanyNotificationsSagas(),
    ClientNotificationsSagas(),
    adminEventRequestsSagas(),
    userTagsSagas(),
    DemoRequestsSagas(),
    payrollSagas(),
    adminDashboardSagas(),
    companyDashboardSagas(),
    activityLogsSagas(),
    companyActivityLogsSagas(),
  ]);
}
